import { useMutation } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';

import type { StudioDetails } from '../model/types';

export interface UpdateStudioParams {
  file: File | string;
  // fileType: 'file' | 'url';
  studio?: StudioDetails;
}

export const updateStudioAPI = async ({
  file,
  // fileType,
  studio,
}: UpdateStudioParams) => {
  const formData = new FormData();

  formData.append('file', file as File);
  formData.append('fileType', 'file');

  // Add stringified class details as payload
  formData.append('payload', JSON.stringify(studio));

  const resp = await baseAPI.patch<unknown>(
    '/studios/update/studio',
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );
  return resp.data;
};

export const useUpdateStudioMutation = () => {
  return useMutation({
    mutationFn: updateStudioAPI,
  });
};
